module.exports = __webpack_public_path__ + "static/media/vintage06.1bc354ca.png";